/// ///////////////////////////////////////////////////////////////
/// ///////////////////////////////////////////////////////////////
/// ///////////////////////// SPANISH /////////////////////////////
/// ///////////////////////////////////////////////////////////////
/// ///////////////////////////////////////////////////////////////
/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>Proceso de Inicio de Sesión en el Portal para Padres EngagED (Interno/Externo)</h4>,
    Interrupt_p0: (
        <h5>
            Para iniciar sesión,{" "}
            <strong>
                <u>NO</u>
            </strong>{" "}
            usará su correo electrónico personal.
        </h5>
    ),
    Interrupt_p1: (
        <>
            Para iniciar sesión, deberá ingresar una dirección de correo electrónico compuesta por su{" "}
            <strong>
                <u>nombre de usuario</u>
            </strong>{" "}
            seguido de{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            en la pantalla de inicio de sesión que aparece a continuación.
            <br />
            Por ejemplo: si su <b>nombre de usuario</b> es <b>jsmith</b>, ingresará{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            .
            <br />
            <br />
            Su contraseña es la misma que usa para acceder a Infinite Campus (padre actual) o la contraseña que creó
            durante la configuración de la cuenta para la Inscripción Abierta (padre externo).
        </>
    ),
    Interrupt_p2: (
        <strong>
            Si necesita ayuda con su nombre de usuario o contraseña, por favor, vaya a{" "}
            <a href="https://password.dcsdk12.org" target="_blank">
                password.dcsdk12.org
            </a>
            .
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>Si no puede acceder después de seguir los pasos anteriores, por favor, contáctenos:</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Inglés
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Español
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Chino
            </a>
            <br />
            Centro de Soporte de TI: <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "NOTA: Los empleados del distrito que son padres actuales deben seguir las instrucciones anteriores utilizando una ventana de navegador de incógnito o privada y/o un navegador diferente.",
    Interrupt_submit: "Proceder a iniciar sesión",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Bienvenido,",
    Main_Nav_HelpfulLinks: "Vínculos útiles",
    Main_Nav_LogOut: "CERRAR SESIÓN",
    Main_Nav_HelpfulLinks_LI_s1: "Contactar el enfermero de mi estudiante",
    Main_Nav_HelpfulLinks_LI_s2: "Calendarios Académicos",
    Main_Nav_HelpfulLinks_LI_s3: "Recursos para padres",
    Main_Nav_HelpfulLinks_LI_s4: "Rutas de autobuses",
    Main_Nav_HelpfulLinks_LI_s5: "Pagos en línea",
    Main_Nav_HelpfulLinks_LI_s6: "Menus de almuerzo",
    Main_Nav_Exit: "SALIR",
    Global_Dashboard: "Panel De Control",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Panel de control de tutores de DCSD",
    Breadcrumb_Back: "Portal para padres de DCSD Engaged",
    Breadcrumb_EPR: "EPR de DCSD archivados",
    Breadcrumb_Translations: "Las traducciones son experimentales",
    Breadcrumb_School_Selection: "Selección de Escuela",
    Breadcrumb_New_Student_Create: "Crear Nuevo Estudiante",
    Breadcrumb_Schools_Making_Offers: "Las Escuelas Están Preparando Ofertas",
    /// /////////////////////////////////////////////////////////
    /// /////////////// OE //////////////////////////////////////
    /// /////////////////////////////////////////////////////////
    OE_Closed_Title: "Ventana de Inscripción Abierta Cerrada",
    OE_Closed_Text:
        "La ventana de Inscripción Abierta ya está cerrada. Por favor regrese durante los periodos de acceso para padres del distrito. Gracias.",
    OE_Student_Info_Breadcrumb: "Información del Estudiante y del Tutor",
    OE_Student_Info_Guardian_Title: "Información Actual del Tutor",
    OE_Student_Info_Student_Title: "Información Actual del Estudiante",
    OE_Student_Info_Email: "Correo Electrónico",
    OE_Student_Info_Address: "Dirección",
    OE_Student_Info_Phone: "Teléfono",
    OE_Student_Info_Current_School: "Escuela Actual",
    OE_Student_Info_Neighborhood_School: "Escuela del Vecindario",
    OE_Student_Info_Scheduled_School: "Escuela Programada para el Próximo Año",
    OE_New_Student: "Nuevo Estudiante",
    OE_Unavailable: "No disponible",
    OE_Form_FirstName: "Nombre Legal del Estudiante",
    OE_Form_FirstName_Description: "Use el nombre legal del estudiante que aparece en el acta de nacimiento",
    OE_Form_MiddleName: "Segundo Nombre Legal del Estudiante",
    OE_Form_MiddleName_Description: "Use el segundo nombre legal del estudiante que aparece en el acta de nacimiento",
    OE_Form_LastName: "Apellido Legal del Estudiante",
    OE_Form_LastName_Description: "Use el apellido legal del estudiante que aparece en el acta de nacimiento",
    OE_Form_Gender: "Género",
    OE_Form_Gender_Male: "Masculino",
    OE_Form_Gender_Female: "Femenino",
    OE_Form_Gender_NonBinary: "No binario",
    OE_Form_Birthdate: "Fecha de Nacimiento del Estudiante",
    OE_Form_Month: "Mes",
    OE_Form_Example: "Ejemplo",
    OE_Form_Day: "Día",
    OE_Form_Year: "Año",
    OE_Form_Clear_Birthdate: "Borrar Campos de Fecha de Nacimiento",
    OE_Form_Student_Address: "Dirección Legal del Estudiante",
    OE_Form_Student_Address_Description:
        "Si reside en el condado de Douglas o en el condado de Elbert, comience a ingresar su dirección y seleccione su dirección de la lista de direcciones recomendadas.",
    OE_Form_Search_Address: "Buscar Dirección",
    OE_Form_Apt_Or_Unit: "número de apartamento o unidad",
    OE_Form_Select: "Seleccionar",
    OE_Form_Address1: "Dirección Línea 1",
    OE_Form_Address2: "Dirección Línea 2",
    OE_Form_City: "Ciudad",
    OE_Form_State: "Estado",
    OE_Form_Zip: "Código Postal",
    OE_Form_App_For_Grade: "Solicitud de Inscripción Abierta para el Grado",
    OE_Form_App_For_Grade_Description1: "Según la edad que tendrá su estudiante en el", // [some variable school year range]
    OE_Form_App_For_Grade_Description2: "año escolar",
    OE_Form_App_For_Grade_Description3: (
        <>
            usted solicitará la inscripción abierta para el grado en el{" "}
            <span className="yellow-box">cuadro amarillo</span> que se muestra a continuación. Si el Grado Solicitado es
            incorrecto, comuníquese con nuestro Departamento de Programación de Elección (Choice Programming Department)
            a <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> para hablar sobre sus circunstancias
            específicas.{" "}
            <span className="will-be">
                Si el Grado Solicitado es incorrecto <span className="bold">y</span> usted continúa con la selección de
                escuelas, su solicitud de inscripción abierta puede ser anulada.
            </span>
        </>
    ),
    OE_Form_Current_Grade: "Grado Actual",
    OE_Form_Applying_For_Grade: "Grado Solicitado",
    OE_Form_Applying_For_Kindergarten:
        "El estudiante solicitará la inscripción abierta a Kínder para el próximo año escolar",
    OE_Form_Applying_For_Kinder_Title: "Solicitando para Kínder",
    OE_Form_Applying_For_Kinder_Body:
        "Por favor confirme que desea ajustar el Grado Solicitado para el estudiante de 1er Grado a Kínder. Si realiza este ajuste después de haber seleccionado las escuelas, estas selecciones de escuelas se eliminarán y deberá completar nuevas selecciones.",
    OE_Form_Reasons_For_Leaving: "Razones para irse",
    OE_Form_Important: "Importante",
    OE_Form_Important_Note: "Nota: Debe seleccionar una o más razones",
    OE_Form_Important_Reasons: "¿Cuáles son las razones para dejar", // [some variable school name]
    OE_Form_Important_Other:
        'Nota: Si selecciona "Otro" como razón para solicitar, debe ingresar un comentario para enviar su elección de escuela.',
    OE_Form_Address_Placeholder: "Empiece a escribir su dirección aquí",
    OE_Buttons_Delete: "Eliminar Inscripción Abierta",
    OE_Buttons_Back_To_Dashboard: "Volver al Panel",
    OE_Buttons_Confirm_And_Proceed: "Confirmar y Continuar",
    OE_Buttons_Cancel: "Cancelar",
    OE_Buttons_Email: "Guardar y Enviarme Mis Elecciones",
    OE_Dialog_Delete_Title: "Confirmación de Eliminación de Inscripción Abierta",
    OE_Dialog_Delete_Body1:
        "Por favor confirme que desea eliminar la solicitud de Inscripción Abierta para el estudiante", // [some variable student name]
    OE_Dialog_Delete_Body2:
        "Esta acción eliminará cualquier dato asociado de elección de escuela de Inscripción Abierta para el estudiante.",
    OE_Dialog_Back_Title1: "Información de inscripción abierta no guardada",
    OE_Dialog_Back_Title2: "Ir al Panel del Tutor",
    OE_Dialog_Back_Body1: "Aún no se ha guardado la solicitud de inscripción abierta para el estudiante",
    OE_Dialog_Back_Body2: "Perderá su progreso si decide volver al panel para padres.",
    OE_Dialog_Back_Body1a: "Aún no se ha guardado la solicitud de inscripción abierta para su estudiante.",
    OE_Schools_Title: "Escuelas Participantes por Región (seleccione hasta 4 escuelas)",
    OE_Schools_Body:
        "Por favor, seleccione una región del distrito para ver una lista de escuelas disponibles para la inscripción abierta. Debe seleccionar al menos una (1) escuela y puede seleccionar un máximo de cuatro (4) escuelas.",
    OE_Schools_Current_Address: "Dirección Actual",
    OE_Schools_Selected: "seleccionadas",
    OE_Schools_My_Schools_Title: "Mis Escuelas Seleccionadas",
    OE_Schools_Selected_Schools_Header: "Estas son las escuelas que ha seleccionado para la Inscripción Abierta",
    OE_Schools_Selected_Schools_Body: (
        <>
            <h6>
                Ha <u>recibido ofertas</u> de las siguientes escuelas:
            </h6>
            <span>
                Puede aceptar una oferta escolar. Todas las demás ofertas se rechazarán automáticamente. También puede
                rechazar alguna/todas las ofertas escolares.
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_Body_2: (
        <>
            <h6>
                您将被加入以下学校的<u>候补名单</u>：
            </h6>
            <span>在公开招生流程的第二轮期间，这些学校可能会直接联系您提供入学录取机会。</span>
        </>
    ),
    OE_Schools_Selected_Schools_Body_2: (
        <>
            <h6>
                Se le agregará a la <u>lista de espera</u> de las siguientes escuelas:
            </h6>
            <span>
                Durante la Segunda Ronda del proceso de Inscripción Abierta, estas escuelas pueden comunicarse con usted
                directamente para extenderle una oferta de inscripción.
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_None: "Su estudiante no tiene selecciones de escuela en este momento",
    OE_Schools_My_Schools_Body:
        'Estas son las escuelas que ha seleccionado para la inscripción abierta. Para cada escuela seleccionada, debe hacer clic en el botón "Seleccionar Razones" para informarnos qué le atrajo a solicitar la inscripción abierta en la escuela. Tenga en cuenta que no podrá guardar/enviar por correo electrónico sus selecciones de escuela hasta que haya ingresado al menos una razón para solicitar el ingreso en cada escuela seleccionada. Para eliminar una selección de escuela, haga clic en el ícono de la papelera en la esquina superior derecha de la tarjeta de la escuela.',
    OE_Schools_My_Schools_Grade: "Solicitando para el Grado",
    OE_Schools_My_Schools_Status: "Estado",
    OE_Schools_My_Schools_Select_Reasons: "Seleccionar Razones",
    OE_Schools_My_Schools_Reasons_Title: "Razones para Solicitar",
    OE_Schools_My_Schools_Reasons_Body: (
        <p>
            Por favor, indique{" "}
            <u>
                <strong>al menos una</strong>
            </u>{" "}
            razón para solicitar la Inscripción Abierta en esta escuela. Puede marcar tantas razones como correspondan y
            modificarlas en cualquier momento durante el plazo de solicitud para padres.
        </p>
    ),
    OE_Schools_My_Schools_Note:
        'Nota: Si selecciona "Otro" como razón para solicitar, debe ingresar un comentario para poder enviar su elección de escuela.',
    OE_Schools_My_Schools_Comment: "Por favor, ingrese un comentario",

    OE_Toast_Email_Error: "No se pudo enviar la confirmación por correo electrónico al tutor.",
    OE_Toast_IC_Error: "Hubo un problema al recuperar los detalles del estudiante de IC.",
    OE_Toast_Email: "Se ha enviado la confirmación de selección de escuela para la Inscripción Abierta a ",
    OE_Toast_Email_Failure:
        "No se pudo enviar la confirmación de selección de escuela porque no existe un correo electrónico de tutor válido.",
    OE_Toast_Deleted:
        "La solicitud de Inscripción Abierta del estudiante se ha eliminado correctamente. Redirigiendo al Panel de Padres.",
    OE_Toast_Saved: "Las selecciones de escuela se han guardado correctamente. Redirigiendo al Panel de Padres.",
    OE_Toast_Offer_Saved:
        "Se ha guardado correctamente la aceptación y/o rechazo de la oferta de selección de escuela.",
    OE_Toast_Saved_Emailed:
        "Se ha guardado correctamente la aceptación y/o rechazo de la oferta de selección de escuela. Redirigiendo al Panel de Padres.",
    OE_Toast_Update_Error: "Hubo un problema al actualizar sus selecciones de escuela.",
    OE_Toast_Delete_Error: "No se pudo eliminar la Inscripción Abierta del estudiante.",
    OE_Toast_Student_Updated:
        "La información del estudiante para la Inscripción Abierta se ha actualizado correctamente.",
    OE_Toast_Data_Error: "Hubo un problema al cargar sus datos. Por favor, recargue la página e inténtelo de nuevo.",
    OE_Toast_Valid_Birthdate: "Por favor, introduzca una fecha válida para el nacimiento del estudiante (MM-DD-AAAA).",
    OE_Toast_Student_Added: "Estudiante agregado correctamente para la Inscripción Abierta.",
    OE_Toast_OE_Error: "No se pudo eliminar la Inscripción Abierta del estudiante.",
    OE_Toast_OE_Saved: "Se ha guardado correctamente la información del estudiante para la Inscripción Abierta.",
    OE_Toast_Student_Updated_2: "Información del estudiante actualizada correctamente.",
    OE_Toast_Region_Error: "Hubo un problema al recuperar las escuelas de la región",
    OE_Toast_Student_Error: "Hubo un problema al recuperar los detalles del estudiante",
    OE_Toast_Reasons_Error: "Hubo un problema al recuperar las Razones para Solicitar",
    OE_Toast_School_Choice_Success:
        "Se ha guardado correctamente la aceptación y/o rechazo de la oferta de selección de escuela.",
    OE_Toast_Redirecting: "Redirigiendo al Panel de Padres",

    OE_Dialog_Window_Closed_Title: "El plazo de Inscripción Abierta ha cerrado",
    OE_Dialog_Window_Closed_Body:
        "El plazo de Inscripción Abierta ya está cerrado. Por favor, regrese durante los plazos de acceso para padres del distrito. Gracias.",
    OE_Dialog_Access_Denied_Title: "Acceso denegado",
    OE_Dialog_Access_Denied_Body:
        "Lo sentimos, pero no tiene permiso para ver a este estudiante. Por favor, regrese al Panel de Padres.",
    OE_Dialog_Ineligible_Title: "Fecha de nacimiento no elegible",
    OE_Dialog_Ineligible_Body:
        "Según la fecha de nacimiento del estudiante, su edad está fuera del rango para la Inscripción Abierta. Por favor, comuníquese con el departamento de Programas de Elección (Choice Programming department) para analizar las circunstancias específicas y/u opciones para la Inscripción Abierta.",
    OE_Dialog_Processing: "Procesando… Por favor, espere",
    OE_Modal_Ineligible: (
        <p>
            Según la fecha de nacimiento que ingresó,{" "}
            <span className="age">la edad del estudiante está fuera del rango para la Inscripción Abierta</span>. Por
            favor, comuníquese con el departamento de Programas de Elección (Choice Programming department) para
            analizar las circunstancias específicas y/u opciones para la Inscripción Abierta.
        </p>
    ),

    OE_Dialog_Incorrect_Info_Title: "Información del estudiante incorrecta",
    OE_Dialog_Incorrect_Info_Body_1: "Lamentamos que haya un error en la información del estudiante para ", // [variable student name]
    OE_Dialog_Incorrect_Info_Body_2: (
        <>
            <div className="top-sentence">
                Por favor, siga los pasos a continuación antes de comenzar su solicitud de Inscripción Abierta...{" "}
            </div>
            <div className="number-container">
                <div className="number">1</div>
                <div className="instruction">
                    Por favor, comuníquese con la escuela de su estudiante para solicitar una corrección de datos. Es
                    posible que la escuela pueda procesar esta solicitud de inmediato o que tome algún tiempo. Gracias
                    por su paciencia.
                </div>
            </div>
            <div className="number-container">
                <div className="number">2</div>
                <div className="instruction">
                    Una vez que haya recibido la confirmación de la escuela de que se ha completado la corrección de
                    datos, regrese para comenzar su solicitud de Inscripción Abierta, donde tendrá la oportunidad de
                    confirmar la exactitud de la información actualizada del estudiante.
                </div>
            </div>
            <div className="number-container">
                <div className="number">3</div>
                <div className="instruction">
                    Una vez que haya confirmado la exactitud de la información, le invitamos a proceder con su solicitud
                    de Inscripción Abierta.
                </div>
            </div>
        </>
    ),

    OE_Buttons_Student_Info_Good: "La información del estudiante es correcta",
    OE_Buttons_Student_Info_Incorrect: "Información del estudiante incorrecta",
    OE_Buttons_Save_Changes: "Guardar cambios",
    OE_Buttons_Continue: "Continuar",
    OE_Buttons_Submit: "Enviar",
    OE_Buttons_Accept: "Aceptar",
    OE_Buttons_Decline: "Rechazar",
    OE_Buttons_Delete: "Eliminar",
    OE_Buttons_Save: "Guardar",

    OE_Dialog_Choices_Will_Delete_Title: "Se eliminarán las selecciones de escuela anteriores",
    OE_Dialog_Choices_Will_Delete_Body: (
        <p>
            El cambio en la dirección particular de este estudiante puede haber resultado en un cambio en las escuelas
            disponibles para la Inscripción Abierta. Como resultado, las selecciones de escuela anteriores se eliminarán
            y deberá volver a seleccionar las escuelas de su interés después de guardar este cambio. Por favor, confirme
            que desea continuar O haga clic en Cancelar y comuníquese con el equipo de Programas de Elección (Choice
            Programming team) en <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> para analizar los
            próximos pasos.
        </p>
    ),
    OE_Dialog_Birthdate_Change_Body: (
        <p>
            El cambio en la fecha de nacimiento de este estudiante ha resultado en un cambio en el grado de solicitud
            para la Inscripción Abierta. Como resultado, deberá volver a seleccionar las escuelas de su interés después
            de guardar este cambio. Por favor, confirme que desea continuar.
        </p>
    ),

    OE_Buttons_Accept_Proceed: "Aceptar y continuar",
    OE_Buttons_Should_Not_Match: "Los nombres no deben coincidir",
    OE_Modal_Names_Match_Title: "Advertencia de coincidencia de nombres de estudiante/tutor",
    OE_Modal_Names_Match_Body_1:
        "El nombre y apellido que ingresó para el estudiante coinciden con el nombre y apellido asociados a su cuenta de tutor.",
    OE_Modal_Names_Match_Body_2: "Nombre del estudiante ingresado:",
    OE_Modal_Names_Match_Body_3: "Nombre de la cuenta del tutor:",
    OE_Modal_Names_Match_Note: "Nota: No se distingue entre mayúsculas y minúsculas",
    OE_Modal_Names_Correction_Title: "Corrección de nombres coincidentes",
    OE_Modal_Names_Correction_Body: (
        <>
            <div>
                Indicó que la cuenta de tutor externa que creó utilizó el nombre y apellido de su estudiante en lugar de
                su nombre y apellido. Antes de continuar con la Inscripción Abierta, comuníquese con el Centro de
                Soporte de TI al{" "}
                <strong>
                    <u>303-387-0001</u>
                </strong>{" "}
                para corregir la información de su cuenta.
            </div>
            <br />
            <div>
                <u>
                    Tenga en cuenta que la información que ingresó para el estudiante no se guardará y deberá volver a
                    ingresarla una vez corregida la información de su cuenta.
                </u>
            </div>
        </>
    ),
    OE_Next_Steps: "Próximos pasos",
    OE_Important_Parent_Info: "Información Importante para Padres",
    OE_Next_Steps_1: "Las escuelas del DCSD ya han extendido ofertas para todas las solicitudes de la Primera Ronda. Tenga en cuenta que es posible que haya recibido o no una oferta de inscripción de sus escuelas seleccionadas. Tenga en cuenta que solo puede aceptar una oferta de inscripción a la vez durante este plazo de revisión.",
    OE_Next_Steps_2: "Las escuelas del DCSD están revisando actualmente las ofertas aceptadas por los padres.",
    OE_Next_Steps_Post: "Después de aceptar una oferta, la escuela se comunicará con usted directamente para informarle sobre los próximos pasos en el proceso de inscripción. No es necesario que se comunique con la escuela, ya que esto puede retrasar el proceso."
};
/* eslint-enable */
